'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = gradient;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utilsJoinPrefixedRules = require('../utils/joinPrefixedRules');

var _utilsJoinPrefixedRules2 = _interopRequireDefault(_utilsJoinPrefixedRules);

var _utilsIsPrefixedValue = require('../utils/isPrefixedValue');

var _utilsIsPrefixedValue2 = _interopRequireDefault(_utilsIsPrefixedValue);

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && value.match(values) !== null) {
    if ((0, _utilsIsPrefixedValue2['default'])(value)) return;

    return (0, _utilsJoinPrefixedRules2['default'])(property, value);
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /workspace/Release/~/inline-style-prefix-all/lib/plugins/gradient.js
// module id = 372
// module chunks = 6